import { useState } from 'react';

import Mexico from '@svg-maps/mexico';
import { Box, Popover, Typography } from '@mui/material';
import { SVGMap } from 'react-svg-map';

const STATE_NAME_ALIASES = {
    'Mexico City': 'Ciudad de México',
    'México': 'Estado de México'
};

const getDisplayName = mapName => STATE_NAME_ALIASES[mapName] || mapName;

const MexicoSalesMap = ({ countrySalesData }) => {
    const [anchorEl, setAnchorEl] = useState(null);
    const [selectedState, setSelectedState] = useState('');

    const getStateSales = (mapName) => {
        const displayName = getDisplayName(mapName);

        return countrySalesData?.[displayName]
            || countrySalesData?.[mapName]
            || { total: 0, sales: 0 };
    };

    const openState = (event) => {
        const mapName = event.currentTarget.getAttribute('name');
        setSelectedState(mapName);
        setAnchorEl(event.currentTarget);
    };

    const closeState = () => {
        setAnchorEl(null);
        setSelectedState('');
    };

    const displayName = getDisplayName(selectedState);
    const stateSales = getStateSales(selectedState);

    return (
        <Box className="map">
            <SVGMap
                map={Mexico}
                className="svg-states"
                locationClassName="map-state"
                locationRole="img"
                locationAriaLabel={location => {
                    const name = getDisplayName(location.name);
                    const sales = getStateSales(location.name);
                    return `${name}. Total de ventas: $${sales.total} MXN`;
                }}
                onLocationMouseOver={openState}
                onLocationMouseOut={closeState}
                onLocationFocus={openState}
                onLocationBlur={closeState}
            />

            <Popover
                id="state-sales-popover"
                sx={{ pointerEvents: 'none' }}
                open={Boolean(anchorEl)}
                anchorEl={anchorEl}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
                transformOrigin={{ vertical: 'top', horizontal: 'left' }}
                onClose={closeState}
                disableRestoreFocus
            >
                <Box sx={{ p: 1 }}>
                    <Typography color="inherit" sx={{ fontWeight: 'bold' }}>
                        {displayName}
                    </Typography>
                    <Typography variant="body1" sx={{ fontSize: 14, fontStyle: 'italic' }}>
                        Total de ventas: ${stateSales.total} MXN.
                    </Typography>
                </Box>
            </Popover>
        </Box>
    );
};

export default MexicoSalesMap;
